// extracted by mini-css-extract-plugin
export default {"modalCIcon":"ModalC_modalCIcon__p8BSs","modalCHeader":"ModalC_modalCHeader__Rl9PS","modalCBody":"ModalC_modalCBody__OrmFD","modalCFooter":"ModalC_modalCFooter__TDhfE"};